import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon, FlameIcon, StarIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, PRODUCT_IMAGE } from '../data/hero';
export function Hero() {
  return <header className="relative overflow-hidden bg-obsidian text-white" data-id="element-109" data-mp="9lbkfd8rfxje">
      <div className="mx-auto grid max-w-6xl gap-y-7 px-5 pb-14 pt-8 text-center lg:grid-cols-[1fr_1.1fr] lg:gap-x-12 lg:gap-y-8 lg:pb-20 lg:pt-16 lg:text-left" style={{
      paddingTop: "0px",
      paddingBottom: "10px",
      gap: "13px"
    }} data-id="element-110" data-mp="4mrsmw7hjrj4">
        <div className="lg:col-start-1 lg:row-start-1 lg:self-end" data-id="element-111" data-mp="xb5rtfab8tw9">
          
          <h1 className="mt-4 font-display text-[46px] font-extrabold uppercase leading-[0.92] tracking-tight sm:text-6xl lg:text-[76px]" style={{
          fontSize: "36px"
        }} data-id="element-112" data-mp="s9zxxe4wz0l5">
            Allenati con metodo.
            <br data-id="element-113" data-mp="3d33d6tuq0lin" />
            Gestisci meglio le energie.
            <br data-id="element-114" data-mp="381xlmzcsr4ap" />
            <span className="text-electric" data-id="element-115" data-mp="381e0l9runzsg">Affronta la gara con più sicurezza.</span>
          </h1>
          <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-white/70 sm:text-lg lg:mx-0" data-id="element-116" data-mp="3j9kbdcsl9jgn">
            Un sistema completo per organizzare il tuo percorso, dalla preparazione al traguardo.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:self-center" data-id="element-117" data-mp="39cflp2zjb5v3">
          <img src={PRODUCT_IMAGE} alt="IL SISTEMA TRIATHLON FULL DISTANCE™ su laptop con i quattro bonus su tablet" width={1536} height={1024} fetchPriority="high" decoding="async" className="animate-floaty mx-auto h-auto w-full max-w-[620px] drop-shadow-[0_30px_40px_rgba(20,125,255,0.18)]" data-id="element-118" data-mp="359jahxcbqc16" />
        </motion.div>

        <div className="lg:col-start-1 lg:row-start-2" data-id="element-119" data-mp="2hjovb94j8bdr">
          <p className="text-sm font-semibold text-white" data-id="element-120" data-mp="2lla52llrs9jq">Il sistema completo in 6 fasi + 4 strumenti pratici per la preparazione</p>
          <p className="mt-2 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-xs text-white/60 lg:justify-start" data-id="element-121" data-mp="s3mc1z88nsws">
            <span className="flex items-center gap-1" data-id="element-122" data-mp="n9i53fyz3kvp">
              <span className="flex text-ember" aria-label="4,9 su 5 stelle" data-id="element-123" data-mp="id9r45wihxq4">
                {Array.from({
                length: 5
              }).map((_, k) => <StarIcon key={k} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-124" data-mp="dbaowzcid6ur" data-mpi={k} />)}
              </span>
              <span className="font-semibold text-white" data-id="element-125" data-mp="161t0ypv7mikb">4,9/5</span>
            </span>
            <span data-id="element-126" data-mp="15zzvhdwc24dw">+300 atleti d'élite e amatoriali</span>
            <span className="inline-flex items-center gap-1" data-id="element-127" data-mp="111esj6pp56lr">
              <ZapIcon className="h-3.5 w-3.5 text-aqua" aria-hidden="true" data-id="element-128" data-mp="x1ecxiqv2pd4" /> Accesso immediato
            </span>
          </p>

          <div className="mt-6 flex justify-center lg:justify-start" data-id="element-129" data-mp="3lu02l0av52z7">
            <CTAButton href="#pricing" data-id="element-130" data-mp="3hrlp6vpyqvfb">Scopri ora il sistema completo</CTAButton>
          </div>

          <ul className="mt-6 flex flex-wrap justify-center gap-2 lg:justify-start" data-id="element-131" data-mp="1x9kw0qpijcjb">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-full border border-white/15 bg-white/[0.04] px-3 py-1.5 text-xs font-medium text-white/80" data-id="element-132" data-mp="21bfs9gsl6zq8">
                <Icon className="h-3.5 w-3.5 text-aqua" aria-hidden="true" data-id="element-133" data-mp="2b1ra8793v9g4" />
                {label}
              </li>)}
          </ul>

          <div className="mt-6 flex flex-col items-center gap-2 lg:items-start" data-id="element-134" data-mp="2fziz0segefg3">
            <p className="inline-flex items-center gap-1.5 rounded-full border border-ember/35 bg-ember/10 px-3.5 py-1.5 text-[11px] font-bold uppercase tracking-wide text-ember" data-id="element-135" data-mp="2kxc6dorhtfhy">
              <FlameIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-136" data-mp="2tyipm5lj14ew" />
              Offerta di lancio a tempo limitato
            </p>
            <p className="flex items-center gap-1.5 text-xs text-white/45" data-id="element-137" data-mp="uoany0svnm13">
              <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-138" data-mp="zmc3wcv0b58c" />
              25 persone stanno guardando questo prodotto in questo momento
            </p>
          </div>
        </div>
      </div>
    </header>;
}